import React from 'react';
import { translate } from '@shakkerai/util-i18n';

export const EmptyState = () => {
  return (
    <div className="w-full mt-[100px] flex justify-center text-[#adadad]">{translate('common_search_noresults')}</div>
  );
};
